import axios from 'axios';
import customAxios from '../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning, faCircleChevronLeft } from "@fortawesome/free-solid-svg-icons";
import "../../../scss/Components/_modal.scss"
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { toast } from 'react-toastify';
import { GlobalVariables } from '../../../globalVar';
import { getToast } from '../../../utils/toastConfig';

function ModalVDelete(props) {
    const {
        visitModalDeleteString,
        visitMDSiteString,
        visitMDVTypeString,
        visitMDTechString,
        visitMDUDateString,
        visitMDDateString,
        modalYesString,
        modalNoString,
    } = useTranslationHook();

    var deleteVisitSiteName = localStorage.getItem("visitSiteNameToDelete");
    var deleteVisitTypeName = localStorage.getItem("visitTypeNameToDelete");
    var deleteVisitTech = localStorage.getItem("visitTechToDelete");
    var deleteVisitDate = localStorage.getItem("visitDateToDelete");
    var deleteVisitUpdatedDate = localStorage.getItem("visitUpdatedDateToDelete");

    var deleteVisitId = localStorage.getItem("visitIdToDelete");

    function deleteVisit() {
        customAxios.request({
            url: `${GlobalVariables.getURL()}deleteVisit/${deleteVisitId}`,
            method: 'delete',
            headers: {
                'Authorization': 'bearer ' + localStorage.getItem('token')
            }
        }).then((response) => {
            console.log(response.data)
            hideS();
        }, (error) => {
            console.log(error);
            getToast({ status: 'error', title: 'Error al eliminar servicio. Vuelve a intentarlo.' });
        });
    } 
    
    function hideS(){
        props.onHide();
        getToast({ status: 'success', title: 'Servicio eliminado exitosamente en la base de datos.' });
        props.getVisits();
    }

    function hideN(){
        props.onHide();
    }
  
    return (
        <Modal 
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdropClassName="modal-backdrop"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="modal-title" id="contained-modal-title-vcenter">
                    {visitModalDeleteString}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span className='delete-info'><strong>{visitMDSiteString}:</strong> {deleteVisitSiteName}</span><br />
                <span className='delete-info'><strong>{visitMDVTypeString}:</strong> {deleteVisitTypeName}</span><br />
                {/* <span className='delete-info'><strong>{visitMDTechString}:</strong> {deleteVisitTech}</span><br /> */}
                <span className='delete-info'><strong>{visitMDDateString}:</strong> {deleteVisitDate}</span><br />
                <span className='delete-info'><strong>{visitMDUDateString}:</strong> {deleteVisitUpdatedDate}</span>
            </Modal.Body>
            <Modal.Footer>
                <button className='modal-button' onClick={() => {deleteVisit()}}><FontAwesomeIcon icon={faWarning}/> {modalYesString}</button>
                <button className='modal-button no' onClick={() => {hideN()}}><FontAwesomeIcon icon={faCircleChevronLeft}/> {modalNoString}</button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalVDelete;